import { epicRequest, reducersMerge, reduxFetchCreator, serverResponse } from 'app'

import type { PermissionsSchema } from 'institutions'

export interface FetchAction {
  institutionId: string
}

const getInitialState = () =>
  serverResponse<PermissionsSchema[]>({
    data: [],
  })

const fetch = reduxFetchCreator<'permissionsFetch', FetchAction, ReturnType<typeof getInitialState>>(
  'permissionsFetch',
  getInitialState(),
)

const permissionsFetchEpic = epicRequest({
  actionType: fetch.actions.permissionsFetch.type,
  errorAction: fetch.actions.permissionsFetchError,
  fulfilledAction: fetch.actions.permissionsFetchFulfilled,
  request: ({ payload }: { payload: FetchAction }) => `permissions/${payload.institutionId}`,
  untilTypes: fetch.actions.permissionsFetchCancel.type,
})

export const actions = {
  ...fetch.actions,
}

export const epics = [permissionsFetchEpic]

export const reducer = reducersMerge(fetch.reducer) as typeof fetch.reducer
